import { Injectable, Renderer2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WindowIndexService {
  constructor() {}

  public setWindowIndex(me: HTMLElement, renderer: Renderer2): void {
    if (!me) {
      console.warn('No element to set z-index');
      return;
    }
    Array.from(document.querySelectorAll('.rfq-drag'), (el: HTMLElement) => {
      renderer.setStyle(el, 'z-index', '50');
    });
    renderer.setStyle(me, 'z-index', '51');
  }

  public getMaxZIndex(): number {
    let count = 0;
    const max = Math.max(
      ...Array.from(document.querySelectorAll('body *'), el => {
        count++;
        return parseFloat(window.getComputedStyle(el).zIndex);
      }).filter(zIndex => !Number.isNaN(zIndex)),
      0
    );
    return max + 1;
  }
}
